import { Divider, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';
import { InvoiceCard as _InvoiceCard } from './components/InvoiceCard';

export const SkeletonInvoiceCard: FC = () => {
  return (
    <_InvoiceCard>
      <_InvoiceCard.Grid>
        <_InvoiceCard.Grid.Element>
          <SkeletonLoader.Title className="w-3/4" />
        </_InvoiceCard.Grid.Element>
        <_InvoiceCard.Grid.Element>
          <p>
            <SkeletonLoader.Text className="w-1/2" />
          </p>
        </_InvoiceCard.Grid.Element>
        <_InvoiceCard.Grid.Element>
          <p>
            <SkeletonLoader.Text className="w-1/2" />
          </p>
        </_InvoiceCard.Grid.Element>
        <_InvoiceCard.Grid.Element>
          <p>
            <SkeletonLoader.Text className="w-1/2" />
          </p>
        </_InvoiceCard.Grid.Element>
        <_InvoiceCard.Grid.Element>
          <p>
            <SkeletonLoader.Text className="w-1/2" />
          </p>
        </_InvoiceCard.Grid.Element>
        <_InvoiceCard.Grid.Element>
          <SkeletonLoader.Badge className="w-1/2" />
        </_InvoiceCard.Grid.Element>
      </_InvoiceCard.Grid>
      <Divider />
      <_InvoiceCard.Actions>
        <_InvoiceCard.Actions.PrimaryAction>
          <SkeletonLoader.Text className="w-32" />
        </_InvoiceCard.Actions.PrimaryAction>
      </_InvoiceCard.Actions>
    </_InvoiceCard>
  );
};
